export default "/institutions/agibank.svg";